module.exports = __webpack_public_path__ + "img/image_555.466063de.webp";